(function () {
  function setExpanded(item, expanded) {
    const button = item.querySelector('.gs-faq-question');
    const answer = item.querySelector('.gs-faq-answer');
    if (!button || !answer) return;

    item.classList.toggle('is-open', expanded);
    button.setAttribute('aria-expanded', String(expanded));
    answer.setAttribute('aria-hidden', String(!expanded));
    answer.inert = !expanded;
  }

  function initSection(section) {
    if (!section || section.dataset.gsFaqReady === 'true') return;
    section.dataset.gsFaqReady = 'true';

    const items = [...section.querySelectorAll('.gs-faq-item')];
    items.forEach((item) => setExpanded(item, false));
    section.querySelector('[data-gs-faq-list]')?.addEventListener('click', (event) => {
      const button = event.target.closest('.gs-faq-question');
      if (!button) return;

      const item = button.closest('.gs-faq-item');
      const shouldOpen = !item.classList.contains('is-open');
      items.forEach((faqItem) => setExpanded(faqItem, faqItem === item && shouldOpen));
    });
  }

  function initWithin(root) {
    if (root.matches?.('.gs-faq-section')) initSection(root);
    root.querySelectorAll?.('.gs-faq-section').forEach(initSection);
  }

  initWithin(document);
  document.addEventListener('shopify:section:load', (event) => initWithin(event.target));
})();
